import { apiPost } from '../../../shared/api-client/index.js';
import type { AiChatEventEnvelope } from '@govard/ai-chat-kit';

export const telegramGroupAgentKeys = {
  turn: (workspaceId: string, candidateId: string, stateVersion: number) =>
    ['telegram-group-agent', workspaceId, candidateId, stateVersion] as const,
};

export interface TelegramGroupAgentTurnResponse {
  candidateId: string;
  conversationId: string;
  turnId: string;
  runId: string;
  status: string;
  candidateStateVersion: number;
  replay: AiChatEventEnvelope[];
}

export async function postTelegramGroupAgentTurn(
  candidateId: string,
  input: { expectedStateVersion: number; locale?: 'ru' | 'en' },
): Promise<TelegramGroupAgentTurnResponse> {
  const locale = input.locale ?? 'ru';
  return apiPost<TelegramGroupAgentTurnResponse, { expectedStateVersion: number }>(
    `/integrations/telegram/group-candidates/${candidateId}/agent-turn?locale=${locale}`,
    { expectedStateVersion: input.expectedStateVersion },
  );
}
